import { createDefault } from "../../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "請求書未作成", enum: "NEW" },
  { value: 2, text: "請求書作成済", enum: "INVOICED" },
]);
